import type { BusinessOption } from '../service-order-form.types.ts'

export function rentalBusinessPricing(option?: BusinessOption) {
  const price = (value: string | null | undefined) => (value == null ? null : Number(value))
  return {
    referencePrice: price(option?.referencePrice),
    agreedPrice: price(option?.referencePrice),
    depositAmount: price(option?.depositAmount),
    managementFee: price(option?.managementFee),
    waterUnitPrice: price(option?.waterUnitPrice),
    electricityUnitPrice: price(option?.electricityUnitPrice)
  }
}
